import { Component, OnInit, ElementRef, ViewChild } from '@angular/core';

import { Validators, FormBuilder, FormGroup, AbstractControl } from '@angular/forms';
import { MatDialog } from '@angular/material';
import { Router } from '@angular/router';

import { PaymentService } from 'src/app/core/services/payment.service';
import { GenericPaymentFormService } from 'src/app/core/services/generic-payment-form.service';
import { DialogYesNoComponent } from 'src/app/core/components/dialog-yes-no/dialog-yes-no.component';

import { BaseManagement } from 'src/app/core/services/base-management';
import { TranslateService } from '@ngx-translate/core';
import { DynamicFormService } from 'src/app/core/services/dynamic-form.service';

declare var $: any;
declare var Payment: any;

@Component({
  selector: 'generic-payment-form',
  templateUrl: './generic-payment-form.component.html',
  styleUrls: ['./generic-payment-form.component.scss']
})
export class GenericPaymentFormComponent extends BaseManagement implements OnInit {
  form : FormGroup;
  @ViewChild('cardForm', { static: true }) cardFormEl:ElementRef;

  paymentType: any = "NA";

  constructor(    
    private router: Router,
    public dialog: MatDialog,
    public dynamicFormService: DynamicFormService,
    private formBuilder: FormBuilder,
  	private paymentService: PaymentService,
    public genericPaymentFormService: GenericPaymentFormService,
    public translate: TranslateService,
  ) { 
    super();

    this.form = this.formBuilder.group({
      "CardNumber":   ['', Validators.compose([Validators.required, Validators.minLength(19)])],
      "Expiry":  ['', Validators.compose([Validators.required, Validators.minLength(9)])],
      "CVC":  [''],
      "CardType":  ['', Validators.compose([Validators.required])],
      "NameOnCard":  ['', Validators.compose([Validators.required])],
      "PaymentAddress": ['', Validators.compose([Validators.required])],
     }, {
        validator: this.paymentInfoValidation
    });           

    this.dynamicFormService.isReadOnly = false;   

    this.onChanges();
  }

  onChanges(): void {
    this.form.get("CardNumber").valueChanges.subscribe(val => {
        var payment = Payment.fns.cardType(val);

        this.paymentType = (payment ? payment.toUpperCase() :  "NA");

        this.form.patchValue({
          "CardType": this.paymentType
        });
    });
  }  

  paymentInfoValidation(control: AbstractControl) {
    let cardNumber = control.get('CardNumber').value; 
    let expiry = control.get('Expiry').value; 

    if(expiry.indexOf("/")>=0 && expiry.length == 9){
      let expiryArray = expiry.split('/');
      let date = new Date();

      let expiryMonth = parseInt(expiryArray[0]);
      let expiryYear = parseInt(expiryArray[1]);
      let currentMonth = date.getMonth();
      let currentYear = date.getFullYear();

      try{
        let specifiedDate = Date.parse(expiryYear + "-" + expiryMonth + "-01");
        let currentDate = Date.parse(currentYear + "-" + currentMonth + "-01");

        if(specifiedDate<currentDate || !specifiedDate){
          control.get('Expiry').setErrors( {invalidDate: true} )
        }
      }catch(e){
        control.get('Expiry').setErrors( {invalidDate: true} )
      }
    }else{
      control.get('Expiry').setErrors( {invalidDate: true} )
    }
   
    return null              
  }  

  ngOnInit() {    
  }

  ngAfterViewInit(){

  }

  tryPay(){
    if(this.isSaving()) return;    
    this.translate
      .get(['payment.tryPaySubmit', 'message.yes', 'message.no'])
      .subscribe((translations) => {  
      let dialogRef = this.dialog.open(DialogYesNoComponent, {
        width: '250px',
        data: {
          msg: translations['payment.tryPaySubmit'],
            yesText: translations['message.yes'],
            noText: translations['message.no'],
        }
      });

      dialogRef.afterClosed().subscribe(result => {      
        if(result==1){
          this.pay();
        }
      });   
    });   
  }

  pay(){  
    if(this.isSaving()) return;    

    this.startSaving("payAndSubmit")

    this.serverError = ""; 

    var paymentData = this.setupPaymentData();
   
    this.genericPaymentFormService.payEvent.next(paymentData);
  }  

  setupPaymentData(){
    let expiry = this.form.controls.Expiry.value; 
    let expiryMonth = 0;
    let expiryYear = 0;

    if(expiry.indexOf("/")>=0 && expiry.length == 9){
      let expiryArray = expiry.split('/');
      let date = new Date();

      expiryMonth = parseInt(expiryArray[0]);
      expiryYear = parseInt(expiryArray[1]);
    }

    let additionalInfo = this.form.controls.PaymentAddress.value;

    additionalInfo.NameOnCard = this.form.controls.NameOnCard.value;

    let card = this.form.controls.CardNumber.value.substr(this.form.controls.CardNumber.value.length - 4);

    additionalInfo.LastFourDigits = card;

    let data = {
      "CardType": this.form.controls.CardType.value,
      "accountNumber": this.form.controls.CardNumber.value,

      "amountOfTransaction": this.genericPaymentFormService.amountToPay + this.genericPaymentFormService.feeAmount,
      "CVV2_CVC2": this.form.controls.CVC.value,

      "expirationMonth": expiryMonth,
      "expirationYear": expiryYear,

      "feeAmount": this.genericPaymentFormService.feeAmount,

      "additionalInfo": JSON.stringify(additionalInfo)
    };    

    return data;
  }

  close(){
    this.paymentService.paymentFormIsVisible = false;
  }
}
